import _taggedTemplateLiteral from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _classCallCheck from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      :host {\n        display: inline-block;\n        cursor: pointer;\n        position: relative;\n        outline: none;\n      }\n      :host([disabled]) {\n        opacity: 0.4 !important;\n        cursor: default;\n        pointer-events: none;\n      }\n      :host([disabled]) svg {\n        background: rgba(0, 0, 0, 0.07);\n      }\n      input {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        box-sizing: border-box;\n        cursor: pointer;\n        opacity: 0;\n      }\n      .knob {\n        transition: transform 0.3s ease;\n      }\n      .knob path {\n        stroke-width: 0.7;\n      }\n      .knob.checked {\n        transform: translateX(48px);\n      }\n      path.knobfill {\n        stroke-width: 3 !important;\n        fill: transparent;\n      }\n      .knob.unchecked path.knobfill {\n        stroke: var(--wired-toggle-off-color, gray);\n      }\n      .knob.checked path.knobfill {\n        stroke: var(--wired-toggle-on-color, rgb(63, 81, 181));\n      }\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    <div style=\"position: relative;\">\n      <svg></svg>\n      <input type=\"checkbox\" .checked=\"", "\" ?disabled=\"", "\"  @change=\"", "\">\n    </div>\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { WiredBase, BaseCSS, fire } from 'wired-lib/lib/wired-base';
import { customElement, property, css, html, query } from 'lit-element';
import { rectangle, hachureEllipseFill, ellipse, svgNode } from 'wired-lib';

var WiredToggle = /*#__PURE__*/function (_WiredBase) {
  _inherits(WiredToggle, _WiredBase);

  var _super = _createSuper(WiredToggle);

  function WiredToggle() {
    var _this;

    _classCallCheck(this, WiredToggle);

    _this = _super.apply(this, arguments);
    _this.checked = false;
    _this.disabled = false;
    return _this;
  }

  _createClass(WiredToggle, [{
    key: "render",
    value: function render() {
      return html(_templateObject(), this.checked, this.disabled, this.onChange);
    }
  }, {
    key: "focus",
    value: function focus() {
      if (this.input) {
        this.input.focus();
      } else {
        _get(_getPrototypeOf(WiredToggle.prototype), "focus", this).call(this);
      }
    }
  }, {
    key: "wiredRender",
    value: function wiredRender() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      _get(_getPrototypeOf(WiredToggle.prototype), "wiredRender", this).call(this, force);

      this.refreshKnob();
    }
  }, {
    key: "onChange",
    value: function onChange() {
      this.checked = this.input.checked;
      this.refreshKnob();
      fire(this, 'change', {
        checked: this.checked
      });
    }
  }, {
    key: "canvasSize",
    value: function canvasSize() {
      return [80, 34];
    }
  }, {
    key: "draw",
    value: function draw(svg, size) {
      var rect = rectangle(svg, 16, 8, size[0] - 32, 18, this.seed);
      rect.classList.add('toggle-bar');
      this.knob = svgNode('g');
      this.knob.classList.add('knob');
      svg.appendChild(this.knob);
      var knobFill = hachureEllipseFill(16, 16, 32, 32, this.seed);
      knobFill.classList.add('knobfill');
      this.knob.appendChild(knobFill);
      ellipse(this.knob, 16, 16, 32, 32, this.seed);
    }
  }, {
    key: "refreshKnob",
    value: function refreshKnob() {
      if (this.knob) {
        var cl = this.knob.classList;

        if (this.checked) {
          cl.remove('unchecked');
          cl.add('checked');
        } else {
          cl.remove('checked');
          cl.add('unchecked');
        }
      }
    }
  }], [{
    key: "styles",
    get: function get() {
      return [BaseCSS, css(_templateObject2())];
    }
  }]);

  return WiredToggle;
}(WiredBase);

__decorate([property({
  type: Boolean
}), __metadata("design:type", Object)], WiredToggle.prototype, "checked", void 0);

__decorate([property({
  type: Boolean,
  reflect: true
}), __metadata("design:type", Object)], WiredToggle.prototype, "disabled", void 0);

__decorate([query('input'), __metadata("design:type", HTMLInputElement)], WiredToggle.prototype, "input", void 0);

WiredToggle = __decorate([customElement('wired-toggle')], WiredToggle);
export { WiredToggle };